const serviceList = [{
  icon: 'serviceOne.png',
  header: '优先试用丰富产品',
  desc: '亲自体验并操作自己感兴趣的产品'
}, {
  icon: 'serviceTwo.png',
  header: '量身定制解决方案',
  desc: '设计一个解决方案来优化您的业务并改进您的产品或服务'
}, {
  icon: 'serviceThree.png',
  header: '评估价格获取服务',
  desc: '获取定制价格，包括成本和定价等，了解具体实施方案和支持服务'
}];
export default {
  name: 'login-service',
  data() {
    return {
      serviceList: serviceList
    };
  },
  props: {
    title: {
      type: String,
      required: true
    }
  }
};